/**
 * Apply configuration change

Deploy new version / update

Recover from unresponsive state

Clear resource or cache issue

Resolve dependency or network error

Routine maintenance / scheduled restart

Manual intervention (with notes)  
 */
export enum ServiceActionReasonCodes {
  CONFIG_CHANGE = "Apply configuration change",
  DEPLOY_NEW_VERSION = "Deploy new version / update",
  RECOVER_UNRESPONSIVE = "Recover from unresponsive state",
  CLEAR_RESOURCE_CACHE = "Clear Resource/Cache Issue",
  ROUTINE_MAINTENANCE = "Routine maintenance / scheduled restart",
  MANUAL_INTERVENTION = "Manual intervention",
}

export interface ServiceActionRequest {
  jobUid: string;
  action: "Start" | "Stop" | "Restart";
  reasonCode?: ServiceActionReasonCodes;
  notes?: string;
  submittedByUserUid?: string;
}

export type ServiceActions = "Start" | "Stop" | "Restart";
